import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { addComment } from "../../actions";
import { localStateSelector } from "../../selectors";
import { type BlogDetailComments } from "../../types";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      commentsCount: localState.comments.length,
      isAdding: localState.status === "AddingComment"
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClick: (data: BlogDetailComments.View.AddCommentFormData) =>
    dispatch(addComment({ ...data, id: props.id, source: props.source }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
